import styled from 'styled-components'

export const ScoreRingWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  box-sizing: border-box;
  background: linear-gradient(135deg, #f848c4 0%, #00b9d5 100%);

  &::before {
    content: '';
    position: absolute;
    inset: 0.1875rem;
    border-radius: 50%;
    background: ${({ theme }) => theme.whiteColor};
  }
`

export const ScoreRingValue = styled.span`
  position: relative;
  z-index: 1;
  font-family: Rubik, verdana, sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  letter-spacing: 0.0187rem;
  text-align: center;
  color: ${({ theme }) => theme.primaryColor};
`
